
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel-sitemap/[[...page]]",
      function () {
        return require("private-next-pages/hotel-sitemap/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel-sitemap/[[...page]]"])
      });
    }
  